<div class="cockpit-content">
  <h1>{{card.title | translate}}</h1>
  <div class="cockpit-view">
    <div class="table-container">
      <h4>{{tableHeaders[0] | translate}}</h4>

      <app-chart-download-button (buttonClick)="exportTable()">
        <h5>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h5>
      </app-chart-download-button>

      <div class="table-wrapper">
        <table>
          <tr>
            <th rowspan="4" class="no-border" scope="col"></th>
            <th colspan="2" class="header centered bold border-bold-left border-bold-right" scope="colgroup">
              {{ 'i18n.cockpit.card.chart.lohnverteilung.unterstesVierte' | translate }}</th>
            <th colspan="2" class="header centered bold border-bold-left border-bold-right" scope="colgroup">
              {{ 'i18n.cockpit.card.chart.lohnverteilung.zweitunterstesViertel' | translate }}
              <br>{{'i18n.cockpit.card.chart.lohnverteilung.median' | translate }} </th>
            <th colspan="2" class="header centered bold border-bold-left border-bold-right" scope="colgroup">
              {{ 'S9.cockpit.card.chart.lohnverteilung.zweitoberstesViertel' | translate }} </th>
            <th colspan="2" class="header centered bold border-bold-left border-bold-right" scope="colgroup">
              {{ 'i18n.cockpit.card.chart.lohnverteilung.oberstes Viertel' | translate }} </th>
            <th colspan="2" rowspan="3" class="header centered bold border-bold-left border-bold-right" scope="colgroup">{{ 'i18n.common.total' | translate }} </th>
          </tr>
          <tr>
            <td colspan="2" class="centered header border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.lohnverteilung.quartil1' | translate }}:
            </td>
            <td colspan="2" class="border-bold-right centered header border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.lohnverteilung.quartil2' | translate }}:
            </td>
            <td colspan="2" class="border-bold-right centered header border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.lohnverteilung.quartil3' | translate }}:
            </td>
            <td colspan="2" class="border-bold-right centered header border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.lohnverteilung.quartil4' | translate }}:
            </td>
          </tr>
          <tr>
            <td colspan="2" class="centered header border-bold-left border-bold-right">
              <span>{{'i18n.cockpit.card.chart.bis' | translate}}&nbsp;{{lohnverteilung.q1Wert | numberFormat: crtLocale }}</span>
            </td>
            <td colspan="2" class="border-bold-right centered header border-bold-left border-bold-right">
              <span>{{'i18n.cockpit.card.chart.bis' | translate}}&nbsp;{{lohnverteilung.q2Wert | numberFormat: crtLocale }}</span>
            </td>
            <td colspan="2" class="border-bold-right centered header border-bold-left border-bold-right">
              <span>{{'i18n.cockpit.card.chart.bis' | translate}}&nbsp;{{lohnverteilung.q3Wert | numberFormat: crtLocale }}</span>
            </td>
            <td colspan="2" class="border-bold-right centered header border-bold-left border-bold-right">
              <span>{{'i18n.cockpit.card.chart.bis' | translate}}&nbsp;{{lohnverteilung.q4Wert | numberFormat: crtLocale }}</span>
            </td>
          </tr>

          <tr>
            <th scope="col" class="centered border-bold-left">{{'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{'i18n.common.anteile' | translate }}</th>
            <th scope="col" class="centered">{{'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{'i18n.common.anteile' | translate }}</th>
            <th scope="col" class="centered">{{'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{'i18n.common.anteile' | translate }}</th>
            <th scope="col" class="centered">{{'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{'i18n.common.anteile' | translate }}</th>
            <th scope="col" class="centered">{{'i18n.common.anzahl' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{'i18n.common.anteile' | translate }}</th>
          </tr>

          <tr class="content">
            <th class="border-bold-left border-bold-right" scope="row">
              {{'i18n.common.maenner' | translate }}
            </th>
            <td>{{ lohnverteilung.q1MaennerAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.q1MaennerAnteil }}</td>
            <td>{{ lohnverteilung.q2MaennerAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.q2MaennerAnteil }}</td>
            <td>{{ lohnverteilung.q3MaennerAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.q3MaennerAnteil }}</td>
            <td>{{ lohnverteilung.q4MaennerAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.q4MaennerAnteil }}</td>
            <td>{{ lohnverteilung.totalMaennerAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.totalMaennerAnteil }}</td>
          </tr>

          <tr class="content">
            <th class="border-bold-left border-bold-right" scope="row">
              {{'i18n.common.frauen' | translate }}
            </th>
            <td>{{ lohnverteilung.q1FrauenAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.q1FrauenAnteil }}</td>
            <td>{{ lohnverteilung.q2FrauenAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.q2FrauenAnteil }}</td>
            <td>{{ lohnverteilung.q3FrauenAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.q3FrauenAnteil }}</td>
            <td>{{ lohnverteilung.q4FrauenAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.q4FrauenAnteil }}</td>
            <td>{{ lohnverteilung.totalFrauenAnzahl }}</td>
            <td class="border-bold-right">{{ lohnverteilung.totalFrauenAnteil }}</td>
          </tr>

          <tr class="content">
            <th class="border-bold-left border-bold-right border-bold-top" scope="row">
              {{'i18n.common.gesamt' | translate }}
            </th>
            <td class="border-bold-top">{{ lohnverteilung.q1MitarbeitendeAnzahl }}</td>
            <td class="border-bold-right border-bold-top">{{ lohnverteilung.q1MitarbeitendeAnteil }}</td>
            <td class="border-bold-top">{{ lohnverteilung.q2MitarbeitendeAnzahl }}</td>
            <td class="border-bold-right border-bold-top">{{ lohnverteilung.q2MitarbeitendeAnteil }}</td>
            <td class="border-bold-top">{{ lohnverteilung.q3MitarbeitendeAnzahl }}</td>
            <td class="border-bold-right border-bold-top">{{ lohnverteilung.q3MitarbeitendeAnteil }}</td>
            <td class="border-bold-top">{{ lohnverteilung.q4MitarbeitendeAnzahl }}</td>
            <td class="border-bold-right border-bold-top">{{ lohnverteilung.q4MitarbeitendeAnteil }}</td>
            <td class="border-bold-top">{{ lohnverteilung.totalMitarbeitendeAnzahl }}</td>
            <td class="border-bold-right border-bold-top">{{ lohnverteilung.totalMitarbeitendeAnteil }}</td>
          </tr>
          <tr class="hint">
            <td colspan="11" class="hint">{{'m1-m2.sprint10.cockpit.card.hinveise-standarisierte-gehaelter' | translate}}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="pdt-20">
      <h5>{{ 'sprint9.cockpit.card.all.diagramm' | translate }}</h5>
      <h6>{{ 'sprint9.cockpit.card.all.ansichteinstellung' | translate }}</h6>

      <div style="display: flex; justify-content: start; flex-direction: row;">
        <div>
          <mat-button-toggle-group #groupGestapeltUngestepelt="matButtonToggleGroup" appearance="standard"
            id="btnTogglegroupGestapeltUngestepelt" name="btnTogglegroupGestapeltUngestepelt" [value]="gestapelt"
            aria-label="Ungestepelt or Gestapelt">
            <mat-button-toggle value="{{gestapelt}}" (change)="selectionGestapeltUngestepeltChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.gestapelt' | translate}}</small>
            </mat-button-toggle>
            <mat-button-toggle value="{{ungestapelt}}" (change)="selectionGestapeltUngestepeltChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.ungestapelt' | translate}}</small>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <div id="svgContainerChartDialogLohnverteilung" class="cockpit-svg-image"></div>
    </div>
  </div>
</div>
